import React from 'react';
import { CheckboxIcon, CheckFillCircle } from 'src/components/icons';

export type Props = {
  status?: boolean;
  checked?: boolean;
  value?: string;
  onChange?: (value: string | number) => void;
  label?: React.ReactNode;
  defaultAnswer?: string[] | null;
};

const CheckBoxWithStatus: React.FC<Props> = ({
  status,
  value,
  checked,
  onChange,
  label,
  defaultAnswer,
}) => {
  return (
    <span
      className={`checkbox status ${checked ? 'check' : ''} ${
        status === undefined ? '' : `${status}`
      }`}
      onClick={() => onChange?.(value!)}
    >
      <CheckboxIcon /> {label}
      {defaultAnswer?.includes(value || '') && <CheckFillCircle />}
    </span>
  );
};

export default CheckBoxWithStatus;
